import {containerStyles} from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingPageContainer";
import {checkoutShippingAddressesStyles} from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingAddresses";
import {customerCardStyles} from "@insite/content-library/Components/CustomerCard";
import {customerSelectorToolbarStyles} from "@insite/content-library/Components/CustomerSelectorToolbar";
import { css } from "styled-components";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { FormInputWrapper } from "@insite/mobius/FormField";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { InputStyle } from "@insite/mobius/TextField";
import { pageHeaderStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingHeader";
import { GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";

checkoutShippingAddressesStyles.container = {
    css: css`
    >${GridOffset}{
        width: 100%;
        margin: 0;
        background-color: ${getColor("info.contrast")};
    }
    `,
}

pageHeaderStyles.buttonsWrapper = {
    css: css`
    display: none;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    position: fixed;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    z-index: 1;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
            ])}
    `,
}

pageHeaderStyles.gridItem = {
    width: 12, 
    css: css`
    padding-bottom: 0px;
    `
}

pageHeaderStyles.heading = {
    variant: "h1"
}

pageHeaderStyles.continueButton = {
    variant: "primary",
    css: css`
        width: 100%;
    `,
}

customerSelectorToolbarStyles.searchTextField = {
    cssOverrides: {
        formField: css`
            flex-basis: 50%;
            >${FormInputWrapper}{
                >${InputStyle}{
                    padding: 12px 35px 12px 10px;
                    &:focus{
                        padding: 12px 35px 12px 10px;
                    }
                }
            }
        `,
    },
}

customerCardStyles.editLink = {
    css: css`
        margin-top: 1rem;
        >${TypographyStyle}{
            display: none;
        }
    `,
}

customerCardStyles.addressGridItem = {
    width: 6, 
    css: css`
    >address[class^="sc"]{
        p{
            font-size: 16px;
            line-height: 22px;
            color: ${getColor("secondary")};
        }
    }
    ` 
}

containerStyles.fulfillmentMethodGridItem = {
    width: 0,
}

containerStyles.fulfillmentMethodAndNotesGridItem = {
    width: 0,
}

containerStyles.fulfillmentMethodAndAddressesGridItem = {
    width: [12, 12, 6, 8, 8],
    css: css`
        >${GridWrapper}{
            >${GridOffset}{
                >${GridItemStyle}{
                    &:first-child{
                        ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`padding: 0px`,
                        null,
                        null,
                        ])}
                    }
                }
            }
        }
    `
}

containerStyles.notesGridItemWide = {
    width: [0, 0, 0, 12, 12],
    css: css`
    // padding-top: 0px;
    padding-bottom: 10px;
    `
}

containerStyles.notesGridItemNarrow = {
    width: 0
}
